<div class="home" [class.home--dashboard]="isAuthenticated || useMockAuth">
  @if (!isAuthenticated && !useMockAuth) {
    <img src="../../../../assets/images/cmt.png" alt="" />
    <app-login></app-login>
  } @else {
    @if (useMockAuth) {
      <div class="auth-status auth-status--compact">
        <span class="badge">🔓 Development Mode - Mock Authentication</span>
      </div>
    }
    <app-dashboard />
  }
</div>
